export default __webpack_public_path__ + "static/media/landing_logo.f2f72707.svg";